export { PostHogPageView } from './PosthogPageView'
